// @ts-nocheck
/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Engage UIApi endpoints
 * API to be used only by the engage UI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ContractSearchRequest,
  ContractSearchResponse
} from '../engageUIApiEndpoints.schemas';

import { customInstance } from '../../client';
import type { ErrorType } from '../../client';




/**
 * @summary searchContracts
 */
export const searchContracts = (
    contractSearchRequest: ContractSearchRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContractSearchResponse>(
      {url: `/api/ui/contracts/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contractSearchRequest, signal
    },
      );
    }
  


export const getSearchContractsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchContracts>>, TError,{data: ContractSearchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchContracts>>, TError,{data: ContractSearchRequest}, TContext> => {

const mutationKey = ['searchContracts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchContracts>>, {data: ContractSearchRequest}> = (props) => {
          const {data} = props ?? {};

          return  searchContracts(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchContractsMutationResult = NonNullable<Awaited<ReturnType<typeof searchContracts>>>
    export type SearchContractsMutationBody = ContractSearchRequest
    export type SearchContractsMutationError = ErrorType<unknown>

    /**
 * @summary searchContracts
 */
export const useSearchContracts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchContracts>>, TError,{data: ContractSearchRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchContracts>>,
        TError,
        {data: ContractSearchRequest},
        TContext
      > => {

      const mutationOptions = getSearchContractsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    